<template>
  <!-- /menu admin phone -->
  <div class="menu-mobile">
    <div class="top">
      <v-btn class="mx-2" fab dark small color="dark" @click="menu = !menu">
        <v-icon dark>menu</v-icon>
      </v-btn>
      <div class="logo">
        <img src="@/assets/img/logo.png" alt />
      </div>
    </div>
    <ul v-if="menu" class="animated" @click="menu = !menu">
      <li>
        <router-link to="/admin">
          <i class="material-icons">dashboard</i>
          Reportes
        </router-link>
      </li>
      <li>
        <router-link to="/admin/ventas">
          <i class="material-icons">shopping_cart</i>
          Ventas
        </router-link>
      </li>
      <li>
          <router-link to="/admin/ventas-no-stock">
            <i class="material-icons">remove_shopping_cart</i>
            Ventas sobre pedido
          </router-link>
        </li>
      <li>
        <router-link to="/admin/ventas/agregar">
          <i class="material-icons">add_circle</i>
          Agregar venta
        </router-link>
      </li>

      <li>
        <router-link to="/admin/gastos">
          <i class="material-icons">credit_card</i>
          Gastos
        </router-link>
      </li>

      <li>
        <router-link to="/admin/agregar-gasto">
          <i class="material-icons">add_circle</i>
          Agregar gasto
        </router-link>
      </li>

      <li>
        <router-link to="/admin/productos">
          <i class="material-icons">local_mall</i>
          Productos
        </router-link>
      </li>
      <li>
        <router-link to="/admin/categorias">
          <i class="material-icons">layers</i>
          Categorías
        </router-link>
      </li>
    </ul>
  </div>
  <!-- /menu admin phone -->
</template>

<script>
import { mapState, mapActions } from "vuex";
const axios = require("axios");
export default {
  name: "MenuMobile",

  data: () => {
    return {
        menu: false,
    };
  },
  methods: {
    ...mapActions(["cerrarSesion"]),
    menuToggle(){
        this.menu = !this.menu
    }
  },
  mounted() {},
  computed: {
    ...mapState(["usuario"])
  }
};
</script>

